import Route from '@ember/routing/route'

export default class BookingPaymentRoute extends Route {}
